import { useSelector, useDispatch } from 'react-redux';
import CloseButton from 'conversations-visitor-experience-components/visitor-widget/CloseButton';
import AIPromptRecommendationsContainer from './AIPromptRecommendationsContainer';
import WelcomeMessage from 'conversations-visitor-experience-components/visitor-widget/components/WelcomeMessage';
import styled from 'styled-components';
import { getWidgetLocation } from '../selectors/widgetDataSelectors/getWidgetLocation';
import { LEFT_ALIGNED } from 'conversations-internal-schema/widget-location/constants/WidgetLocations';
import { usePromptsHeight } from '../hooks/usePromptsHeight';
import { useCustomerAgentHover } from 'conversations-visitor-experience-components/contexts/CustomerAgentHoverContext';
import { useConsentPromptData } from '../hooks/useConsentPromptData';
import QuickReplyGroupOutsideChatContainer from './QuickReplyGroupOutsideChatContainer';
import { getIsAIChatbot } from '../selectors/widgetDataSelectors/getIsAIChatbot';
import { toggleOpen } from '../actions/WidgetActions';
import { closeInitialMessageBubble } from '../initial-message-bubble/actions/closeInitialMessageBubble';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WelcomePageWrapper = styled.div.withConfig({
  displayName: "WidgetWelcomePage__WelcomePageWrapper",
  componentId: "sddvl1-0"
})(["position:relative;display:flex;flex-direction:column;width:100%;align-items:", ";"], ({
  widgetLocation
}) => widgetLocation === LEFT_ALIGNED ? 'flex-start' : 'flex-end');
const WelcomePageContent = styled.div.withConfig({
  displayName: "WidgetWelcomePage__WelcomePageContent",
  componentId: "sddvl1-1"
})(["margin-top:25px;display:flex;flex-direction:column;gap:10px;width:100%;"]);
const HeightCalcWrapper = styled.div.withConfig({
  displayName: "WidgetWelcomePage__HeightCalcWrapper",
  componentId: "sddvl1-2"
})(["display:flex;flex-direction:column;gap:10px;align-items:", ";"], ({
  widgetLocation
}) => widgetLocation === LEFT_ALIGNED ? 'flex-start' : 'flex-end');
const WidgetWelcomePage = ({
  onClose,
  initialMessage
}) => {
  const dispatch = useDispatch();
  const {
    isHoverActive
  } = useCustomerAgentHover();
  const widgetLocation = useSelector(getWidgetLocation);
  const {
    consentPromptEnabled
  } = useConsentPromptData();
  const isAIChatbot = useSelector(getIsAIChatbot);
  const disableAnimation = !isAIChatbot;
  const showWelcomeMessage = initialMessage && !isAIChatbot;
  const {
    height: promptsHeight,
    ref: promptsRef
  } = usePromptsHeight(isHoverActive);
  const handleWelcomeMessageClick = () => {
    dispatch(toggleOpen({
      isOpened: true,
      isUser: true,
      openedFrom: 'welcome message click'
    }));
  };
  const handleCloseButtonClick = () => {
    dispatch(closeInitialMessageBubble());
    onClose();
  };
  return /*#__PURE__*/_jsx(WelcomePageWrapper, {
    widgetLocation: widgetLocation,
    children: /*#__PURE__*/_jsxs(WelcomePageContent, {
      children: [/*#__PURE__*/_jsx(CloseButton, {
        onClick: handleCloseButtonClick,
        "aria-label": I18n.text('conversations-visitor-ui.visitorExperienceAriaLabels.closeWelcomePage'),
        "data-test-id": "ask-me-anything-close-button",
        widgetLocation: widgetLocation,
        promptsHeight: promptsHeight,
        disableAnimation: disableAnimation,
        consentPromptEnabled: consentPromptEnabled
      }), /*#__PURE__*/_jsxs(HeightCalcWrapper, {
        ref: promptsRef,
        widgetLocation: widgetLocation,
        children: [showWelcomeMessage && /*#__PURE__*/_jsx(WelcomeMessage, {
          onClick: handleWelcomeMessageClick,
          initialMessage: initialMessage
        }), /*#__PURE__*/_jsx(AIPromptRecommendationsContainer, {
          clickedFrom: "customer agent launcher"
        }), /*#__PURE__*/_jsx(QuickReplyGroupOutsideChatContainer, {
          widgetLocation: widgetLocation
        })]
      })]
    })
  });
};
WidgetWelcomePage.displayName = 'WidgetWelcomePage';
export default WidgetWelcomePage;